import {
    useMemo,
} from 'react'
import {
    useLocation,
} from 'react-router-dom'
import aPricingRateCardRequests from 'app/requests/APricingRateCard/APricingRateCard.requests'
import {
    RateCardStatus,
} from 'app/enums/label.enums'

import ARateCardForm from '../ARateCardForm'

type Props = {
    onSuccess: (newRateCard: any) => void,
}

export default function ARateCardCreate({
    onSuccess,
}: Readonly<Props>) {
    const {
        state,
    } = useLocation()

    const requestParams = useMemo(() => {
        return aPricingRateCardRequests.create()
    }, [])

    const defaultValue = useMemo(() => {
        if (state?.copyFrom) {
            return {
                account: state.copyFrom.account,
                status: RateCardStatus.IN_PROGRESS,
                copyFrom: state.copyFrom.id,
            }
        }
        return undefined
    }, [state?.copyFrom])

    return (
        <ARateCardForm
            value={defaultValue}
            onSuccess={onSuccess}
            requestParams={requestParams}
        />
    )
}
